import i18n from 'i18next';
import LanguageDetector, { DetectorOptions } from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import config from './config';

const baseUrl = import.meta.env.BASE_URL.replace(/\/+$/, '');

const detectorOptions: DetectorOptions = {
  order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
  lookupQuerystring: 'lng',
  lookupCookie: config.Translation.CookieName,
  cookieDomain: config.Translation.CookieDomain,
  caches: ['cookie'],
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(Backend)
  .init({
    fallbackLng: 'en',
    // We only ship base language bundles (`en`, `fr`).
    // Loading region variants such as `en-US` makes the backend fetch files we do
    // not publish in dev, which can leave React Suspense stuck behind translation
    // loading even though the base language bundle exists.
    supportedLngs: ['en', 'fr'],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    react: {
      // Provider-level hooks call `useTranslation()` during app bootstrap.
      // Suspending there blocks the entire live shell behind the root fallback.
      // Keep namespace loading async, but do not make first paint depend on it.
      useSuspense: false,
    },
    // i18next-http-backend@1.x (pinned to match dashboard/design-system's i18next
    // stack) doesn't export its options interface by name, so this is checked
    // structurally against `init()`'s expected shape via inline contextual typing
    // rather than a separately-annotated variable.
    backend: {
      loadPath: `${baseUrl}/locales/{{lng}}/{{ns}}.json`,
      requestOptions: {
        cache: 'default',
      },
    },
    detection: detectorOptions,
  });

export default i18n;
